export default __webpack_public_path__ + "static/media/faqimg.08c99ee5.png";